import { Autocomplete } from '../fields';
import { LabelRequired } from '../custom/LabelRequired';
import { useTranslation } from 'react-i18next';
import useAppSubmitting from '../../hooks/useAppSubmitting';
import useAccounts from '../../hooks/useAccounts';
import useConnectionMode from '../../hooks/useConnectionMode';
import useIsInputsOnlyLayout from '../../hooks/useIsInputsOnlyLayout';
import amIVisible from '../../componentControl/registry';
import { useDispatch } from 'react-redux';
import { useNotification } from '../../utils/helpers/notifications';
import { setCurrentComponent } from '../../slices/dashboardSlice';
import { Text } from '../custom/text';
import { Card, Skeleton } from 'antd';
import { Flex } from '@react-css/flex';
import { Box } from '../custom/box';

export const MapSalesByProducts = ({ formik }) => {
  const { showNotification } = useNotification();
  const [isAppSubmitting] = useAppSubmitting();
  const { postingMethod, incomeAccount } = formik.values
  const isTypeCategory = postingMethod !== 'invoice';
  const [isLoadingAccounts, accountsList] = useAccounts('items');
  const [, softwareName] = useConnectionMode();
  const { t } = useTranslation();
  const [isInputsOnlyLayout] = useIsInputsOnlyLayout();
  const isLoading = isInputsOnlyLayout ? false : isLoadingAccounts;
  const canShowSalesIndividual = amIVisible("sales individual")
  const dispatch = useDispatch()
  const canShowBothProductAndCategories = amIVisible("sales can show both product and categories")

  const gotoMapping = () => {
    if (formik.dirty) {
      showNotification("Save the current changes to proceed", "error")
    } else {
      let comp = 'product'
      if (!isTypeCategory && canShowBothProductAndCategories) {
        comp = 'category'
      } else if (isTypeCategory) {
        comp = 'category'
      }

      dispatch(setCurrentComponent("sales " + comp + " mapping"))
    }
  };

  const handleNavigation = () => {
    if (isAppSubmitting) {
      showNotification(t('Please wait for data to save'), 'error');
    } else if (incomeAccount) {
      gotoMapping();
    } else {
      showNotification(t(isInputsOnlyLayout ? 'DefaultAccountTextInputFirst' : 'DefaultAccountFirst'), 'error');
    }
  }

  const getLabel = () => {
    if (!isTypeCategory && canShowBothProductAndCategories) {
      return "Map individual Revenue Classes and products"
    } else if (isTypeCategory) {
      return "Map individual Revenue Classes"
    }

    return "Map individual products"
  }

  return <Card type="inner"   title={
    <Text fontSize={"large"} fontWeight="bolder">{isTypeCategory ? 'Sales by Revenue Classes' : 'Sales by products'}</Text>
  } style={{ marginBottom: "1rem" }}>
    <Text color="gray-600" size="small">
      {t(
        isTypeCategory ? 'SalesByCategoryDescription' : 'SalesByProductDescription', {
        swName: softwareName,
      })}
    </Text>
    <Flex>
      <Box width="49%" pr="1.1rem">
        <LabelRequired htmlFor="incomeAccount">
          {t('Default sales account')}
        </LabelRequired>
        <Autocomplete
          id="incomeAccount"
          name="incomeAccount"
          isLoading={isLoading}
          options={accountsList}
          placeholder={
            t(isInputsOnlyLayout ? 'Enter default sales account' : 'Select an account')
          }
        />
      </Box>
      {canShowSalesIndividual && <Flex style={{ marginTop: "45px" }}>
        {isLoading ?
          <Skeleton.Input size="small" /> :
          <Text link size="small" fontWeight="bolder" onClick={handleNavigation}>
            {getLabel()}
          </Text>
        }
      </Flex>}
    </Flex>
  </Card>;
};
